import { createContext, useContext } from 'react'

export type TelemetryConsentContextValue = {
  /** True iff the user has explicitly opted in. False is the safe default. */
  consenting: boolean
  /** True once the IDB read has resolved (avoids flicker on first paint). */
  loaded: boolean
  /** True once the user has interacted with the consent prompt or toggle at least once. */
  dismissed: boolean
  /** Persists the new value and marks the prompt dismissed. */
  setConsent: (next: boolean) => Promise<void>
  /** Marks the prompt dismissed without granting consent (ADR-035 — persistent no). */
  dismissPrompt: () => Promise<void>
}

export const TelemetryConsentContext =
  createContext<TelemetryConsentContextValue | null>(null)

export function useTelemetryConsent(): TelemetryConsentContextValue {
  const value = useContext(TelemetryConsentContext)
  if (!value) {
    throw new Error('useTelemetryConsent must be used inside <TelemetryConsentProvider>')
  }
  return value
}
